import { render, staticRenderFns } from "./TabLink.vue?vue&type=template&id=9e5fe1d6&scoped=true"
import script from "./TabLink.vue?vue&type=script&lang=js"
export * from "./TabLink.vue?vue&type=script&lang=js"
import style0 from "./TabLink.vue?vue&type=style&index=0&id=9e5fe1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5fe1d6",
  null
  
)

export default component.exports